<body>
  <div class="card">
    <div class="card-header">
      <div class="card-title-skeleton skeleton"></div>
      <div class="currency-symbol-skeleton skeleton"></div>
    </div>
    <div class="card-value-skeleton skeleton"></div>
    <div class="change-value-skeleton skeleton"></div>
    <div class="change-description-skeleton skeleton"></div>
  </div>
</body>
